

export interface guser {
    userDisplayName: string;
    userId: string;
    userMail: string;
    companyid: string;
    name: string;
    tier: number;
    subscriptionid: string;
    status: string;
}

export interface gcontentlist {
    fileid: string;
    srcPageNum: number;
    srcText: string;
    destPageId: number;
    destPageNum: number;
}

export interface gpagemap {
    [key: string]: number;
}

export interface SaveOptions {
    sharewithcode?: boolean;
    headerimageurl?: string;
}

export interface gpagecontent {
    page_num: string;
    text: string;
}

export interface gpagedimensions {
    page_number: string;
    width: number;
    height: number;
    scaledHeight?: number;
}

export interface gchunktopics {
    topics: string[];
    page_num: Number;
}

export interface gfileassourceoption {
    fileid: string;
    name: string;
}

export interface gfile {
    fileid: string;
    name: string;
    size: string;
    full_path: string;
    modified: string;
    groupids: string;
    groupnames: string;
    filerole: string;
    ownerid: string;
    filepermlevel: number;
    pagemap: gpagemap;
    contentlist: gcontentlist[];
    pagecontent: gpagecontent[];
    globalXplrrOrder?: number;
    indexchunks?: number[];
    pagedimensions: gpagedimensions[];
    sourcetype: string;
    sourceurl: string;
    docstatus: string;
    invoicedata: string | any;
    contentlistai: string;
    doc_category: string;
    transcription: gtranscriptentry[];
    transcriptionkey: number;
    transcriptname: string;
    diffids: number[];
    approved: number;
    topics: gchunktopics[];
    tag: string;
    aiinteractions: string[];
    parent_url?: string;
    file_url?: string;
    status_info?: string;
    docsummary?: any
    rekey?: string;
    doc_cat_ai?: string;
    ext_stamp?: string; // ext sync timestamp
    dash_list?: number; // 1 ￫ data item is shown as a sidebar list (files.extra_conf.dash_list)
}

export interface gXplrrExtendedFileList {
    globalXplrrOrder: number;
    fileid: string;
    name: string;
    size: string;
    full_path: string;
    modified: string;
    groupids: string;
    groupnames: string;
    filerole: string;
    ownerid: string;
    filepermlevel: number;
    pagemap: gpagemap;
    contentlist: gcontentlist[];
    pagecontent: gpagecontent[];
    pagedimensions: gpagedimensions[];
    sourcetype: string;
    sourceurl: string;
    docstatus: string;
    invoicedata: string | any;
    contentlistai: string;
    doc_category: string;
    transcription: gtranscriptentry[];
    transcriptionkey: number;
    transcriptname: string;
    diffids: number[];
    approved: number;
    topics: gchunktopics[];
    tag: string;
    aiinteractions: string[];
    parent_url?: string;
    file_url?: string;
    status_info?: string;
    docsummary?: any
    rekey?: string;
    doc_cat_ai?: string;
}

export interface gfileuserselect {
    fileid: string;
    name: string;
    modified: string;
    tag: string;
    size: string;
    doc_category: string;
    doc_status: boolean;
    selected: boolean;
}




export interface gen_opt_obj {
    use_mermaid: number;        // on responses instad of chartjs, use mermaid (wip)
    use_dynamic_dbs?: number;   // on content ingestion: create a dynamic table for integration data
}

export const emptyuser = (): guser => {
    return { userDisplayName: "", userId: "", userMail: "", companyid: "", name: "", tier: 0, subscriptionid: "", status: "" }
}

export const emptycompany = (): gactivecomp => {
    return {
        companyid: "",
        companyname: "",
        permissionlevel: 0,
        licensingkind: 0,
        alloweddomains: "",
        allowqueststocreate: 1
    };
};

export const permissionlevels = (): Record<number, string> => {
    return { 1: "viewer", 2: "member", 3: "owner" }
}

export const emptyloggedinuser = (): gloggedinuser => {
    return { userId: "", mail: "", token: ""}
}


/** Campaign-keyed value entry for per-campaign settings */
export type gcampaignkv = { campaign: string; value: string };

/** ### CCA Root Config
 * - `greeting`: Greeting message (root/legacy)
 * - `greetings`: Per-campaign greetings array
 * - `custaiinsts`: Per-campaign general-scenario instructions array
 * - `imp_words_arr`: Per-campaign domain-specific words array
 * - `scenarios`: Array of CCA Scenarios
 * - `rate`: Speech speed
 * - `usecase`: Use case ID `1` for exact collection, `2` soft
 * - `tts`: TTS Engine `1` for AZ, `2` for EL
*/
export interface gconvoconfig {
    greeting: string;
    greetings?: gcampaignkv[];
    custaiinsts?: gcampaignkv[];
    imp_words_arr?: gcampaignkv[];
    scenarios: gscenarios[];
    rate: number;
    usecase: number;
    tts: number;
    lookback_mins: number;
    imp_words: string;
    voice: string;
    call_window_start?: string;  // 'HH:MM', e.g. '08:00'
    call_window_end?: string;    // 'HH:MM', e.g. '18:00'
    dyn_struct_latest?: number
}

export const empty_contenttype_config_string:string = '{contenttype: [{ type: "all_content", description: "All Content not covered by other Content Types", fields:[], autofield: true }]}';

export const empty_line_config_string:string        = '{account_sid: "", from: "", twi_lmapp: ""}';


export const empty_extraction_field_list:gextractionfieldlist = { excl: [], instr: [] };
export const empty_extraction_field_list_string:string = '{"excl":[], "instr":[]}';

export const empty_new_group: gnewgroup = {
    id: "",
    groupname: "",
    description: "",
    scrt: "",
    appid: "",
    specializedSettings: {}
}

export const empty_spo_config = {
    tenant_id: "",
    full_lib_url: "",
    graph_full_url: "",
    client_id: "",
    enabled: 0,
    client_secret: ""
};




export const empty_convo_config: gconvoconfig = {
    greeting: '',
    greetings: [],
    custaiinsts: [],
    imp_words_arr: [],
    scenarios: [],
    rate: 0,
    usecase: 0,
    tts: 0,
    lookback_mins: 0,
    imp_words: '',
    voice: '',
    call_window_start: '08:00',
    call_window_end: '18:00',
};

export const empty_contenttype_config   = {
    contenttype: [
        {
            type: "all_content",
            description: "All Content not covered by other Content Types",
            fields: [],
            autofield: true
        }
    ]
};

export const empty_line_config          = {
    account_sid: "",
    from: "",
    twi_lmapp: ""
};

export interface ggroup {
    groupid: string;
    groupname: string;
    userid: string;
    permissionlevel: number;
    filecount: number;
    description: string;
    sharewithcode: boolean;
    custaiinst: string;
    custgreetingmessage: string;
    isintegrateddata: number;
    allowyoutube: number;
    allowweb: number;
    enabledocaudio: number;
    retrievecount: number;
    sectionoverlap: number;
    maxsectionlength: number;
    sentencesearchlimit: number;
    inscope: number;
    temperature: number;
    responsetokenlimit: number;
    disablecitationhighlighting: number;
    strictness: number;
    invoicesgroup: number;
    questionsuggestions: number;
    nosidebysideview: number;
    isowner: number;
    dailymsgs: number;
    premiumby: string;
    oid: number;
    tier: number;
    premwhen: number;
    companyid: string;
    apikey: string;
    producecontentlist: number;
    producequestions: number;
    assistanttype: string;
    showexamplequestionsonstart: number;
    headerimageurl: string;
    manualquestionsuggestions: string;
    usedocintel: number;
    extractionfieldlist: gextractionfieldlist;
    allowaudiodocentry: number;
    forceocr: number;
    allowvideofiles: number;
    convomode: number;
    convolang: string;
    hideaisearch: number;
    docextractionconfig: any[]; // Updated to any[]
    docextractionuseauto: number;
    landingpage: number;
    urllinkextraction: number;
    spo_config: gspoconfig;
    convo_config: gconvoconfig;
    contenttype_config: gcontenttypeconfig;
    line_config: glineconfig;
    aiquestionslang: string;
    perchunkmeta: number;
    pdfcontentlist: number;
    showchartsinuni: number;
    enhance_img: number;
    usenewmodel: number;
    uselatestretrieval: number;
    useapproval: number;
    allowaudiofiles: number;
    landonmanage: number;
    itemupd: string
    viewerscanupload: number;
    hideroottabs: number;
    dontloadlastconvo: number;
    splitinv: number;
    allowsimpleconvo: number;
    allowgroupconnect: number;
    campaigns_enabled: number;
    def_campaign_id: string;
    camp_join: campaignidnamepair[] | string;
    gen_opt?: gen_opt_obj;
}





/** Selected Group */
export interface gselectedgroup {
    selectionId: string;
    selectionText: string;
    permissionlevel: number;
    description: string;
    sharewithcode: boolean;
    filecount: number;
    custaiinst: string;
    custgreetingmessage: string;
    isintegrateddata: number;
    allowyoutube: number;
    allowweb: number;
    enabledocaudio: number;
    retrievecount: number;
    sectionoverlap: number;
    maxsectionlength: number;
    sentencesearchlimit: number;
    inscope: number;
    temperature: number;
    responsetokenlimit: number;
    disablecitationhighlighting: number;
    strictness: number;
    invoicesgroup: number;
    questionsuggestions: number;
    nosidebysideview: number;
    isowner: number;
    dailymsgs: number;
    premiumby: string;
    oid: number;
    tier: number;
    premwhen: number;
    companyid: string;
    apikey: string;
    producecontentlist: number;
    producequestions: number;
    assistanttype: string;
    showexamplequestionsonstart: number;
    headerimageurl: string;
    manualquestionsuggestions: string;
    usedocintel: number;
    extractionfieldlist: gextractionfieldlist;  // invoice main config
    allowaudiodocentry: number;
    forceocr: number;
    allowvideofiles: number;
    convomode: number;
    convolang: string;
    hideaisearch: number;
    docextractionconfig: any[];                 // cca scenario collect fields
    docextractionuseauto: number;
    landingpage: number;
    urllinkextraction: number;
    spo_config: gspoconfig;
    convo_config: gconvoconfig;                 // conversation config
    contenttype_config: gcontenttypeconfig;     // doc processing main config
    line_config: glineconfig;
    aiquestionslang: string;
    perchunkmeta: number;
    pdfcontentlist: number;
    showchartsinuni: number;
    enhance_img: number;
    usenewmodel: number;
    uselatestretrieval: number;
    useapproval: number;
    allowaudiofiles: number;
    landonmanage: number;
    itemupd: string
    viewerscanupload: number;
    hideroottabs: number;
    dontloadlastconvo: number;
    splitinv: number;
    allowsimpleconvo: number;
    allowgroupconnect: number;
    campaigns_enabled: number;
    def_campaign_id: string;
    camp_join: campaignidnamepair[] | string;
    gen_opt?: gen_opt_obj;
}

export interface campaignidnamepair {
    id: string;
    name: string;
}

export const empty_gen_opt: gen_opt_obj = {
    use_mermaid: 0,
    use_dynamic_dbs: 0
}

export const emptygroup = (): gselectedgroup => {
    return {
        selectionId: "",
        selectionText: "",
        permissionlevel: 0,
        description: "",
        sharewithcode: false,
        filecount: 0,
        custaiinst: "",
        custgreetingmessage: "",
        isintegrateddata: 0,
        allowyoutube: 1,
        allowweb: 1,
        enabledocaudio: 1,
        retrievecount: 5,
        sectionoverlap: 200,
        maxsectionlength: 3000,
        sentencesearchlimit: 200,
        inscope: 1,
        temperature: 0.7,
        responsetokenlimit: 3024,
        disablecitationhighlighting: 0,
        strictness: 3,
        invoicesgroup: 0,
        questionsuggestions: 0,
        nosidebysideview: 0,
        isowner: 0,
        dailymsgs: 0,
        premiumby: "",
        oid: 0,
        tier: 0,
        premwhen: 0,
        companyid: "",
        apikey: "",
        producecontentlist: 0,
        producequestions: 0,
        assistanttype: "",
        showexamplequestionsonstart: 0,
        headerimageurl: "",
        manualquestionsuggestions: "",
        usedocintel: 0,
        extractionfieldlist: empty_extraction_field_list,
        allowaudiodocentry: 0,
        forceocr: 0,
        allowvideofiles: 0,
        convomode: 0,
        convolang: "",
        hideaisearch: 0,
        docextractionconfig: [],
        docextractionuseauto: 0,
        landingpage: 0,
        urllinkextraction: 0,
        spo_config: empty_spo_config,
        convo_config: empty_convo_config,
        contenttype_config: empty_contenttype_config,
        line_config: empty_line_config,
        aiquestionslang: "",
        perchunkmeta: 0,
        pdfcontentlist: 0,
        showchartsinuni: 0,
        enhance_img: 0,
        usenewmodel: 0,
        uselatestretrieval: 0,
        useapproval: 0,
        allowaudiofiles: 0,
        landonmanage: 0,
        itemupd: "",
        viewerscanupload: 0,
        hideroottabs: 0,
        dontloadlastconvo: 0,
        splitinv: 0,
        allowsimpleconvo: 0,
        allowgroupconnect: 0,
        campaigns_enabled: 0,
        def_campaign_id: '',
        camp_join: [],
        gen_opt: empty_gen_opt
    }
}

export type ownersProps = {
    userid: string;
    username: string;
    level: number;
    mail: string;
    isnew: boolean;
}

export interface gnewgroup {
    id: string;
    groupname: string;
    description: string;
    appid: string;
    scrt: string;
    specializedSettings: any;
    extractionfieldlist?: any;
}

export interface glineconfig {
    account_sid: string;
    from: string;
    twi_lmapp: string;
    from_number?: string;
}

export interface gspoconfig {
    tenant_id: string;
    full_lib_url: string;
    graph_full_url: string;
    client_id: string;
    enabled: number;
    client_secret: string;
}


/** ### CCA Scenario
 * - `id`: ID
 * - `name`: Name
 * - `condition`: Condition to Run
 * - `description`: Instructions
 * - `linked_fields`: Linked Field IDs
*/
export interface gscenarios {
    id: string;
    name: string;
    condition: string;
    description: string;
    linked_fields: string[];
    campaignid?: string;         // optional, for future use in campaign based extractions
}

export interface gcompusrs {
    company: string;
    userid: string;
    usermail: string;
    username: string;
}

export interface gallusrs {
    companyid: string;
    userid: string;
    usermail: string;
    username: string;
    permissionlevel: number;
    tier: number;
}
export interface guseraddition {
    membermail: string;
    memberdisplayname: string;
    membercompany: string;
    memberlevel: number;
}

export interface gcompmbrshps {
    groupid: string;
    groupname: string;
    memberid: string;
    memberusername: string;
    membermail: string;
    membercompany: string;
    memberlevel: number;
    isinvite: number;
}

export interface gactivecomp {
    companyid: string;
    companyname: string;
    permissionlevel: number;
    licensingkind: number;
    alloweddomains: string;
    allowqueststocreate: number;
}

export interface gcompflat {
    companyid: string;
    companyname: string;
    permissionlevel: number;
    licensingkind: number;
    alloweddomains: string;
    allowqueststocreate: number;
}

export interface gnewcomp {
    companyid: string;
    companyname: string;
    licensingkind: number;
}

export interface gloggedinuser {
    userId: string;
    mail: string;
    token: string;
}

export interface ispdfmodalopen {
    defaultFile: string;
    startPage: string;
    isOpen: boolean;
    searchString: string;
    contentlist: gcontentlist[];
    pagemap: gpagemap;
    fileId: string;
    refPageNum: string;
    isCitation: boolean;
    rndo: string;
    activeGroupId: string;
    fileList: gfile[];
    fl: gfile | undefined;
}

export interface ispdfdiffmodalopen {
    defaultFile1: string;
    defaultFile2: string;
    isOpen: boolean;
    searchString: string;
    fileId1: string;
    fileId2: string;
    refPageNum: string;
    isCitation: boolean;
    rndo: string;
    activeGroupId: string;
    fileList: gfile[];
    fl1: gfile | undefined;
    fl2: gfile | undefined;
    diff: gdiffresponse[] | undefined;
}

export interface gpdfcache {
    [key: string]: gpdfcachevalue;
}

export interface gpdfcachevalue {
    base64string: string;
    fileid: string;
    name: string;
    modified: string;
}

export interface gXplrrCitationChangeCallback {
    fileid: string;
    filename: string;
    destPageNum: string;
    isCitation: boolean;
    rndo: string;
}

// space ⇒ file ⇒ order
export interface gXplrrContentOrder {
    [key: string]: gXplrrSpaceOrder;
}

// keep files in order
export interface gXplrrSpaceOrder {
    [key: number]: gXplrrFileOrder;
}

export interface gXplrrFileOrder {
    order: number;
    opened: boolean;
    fileItemOrder: gXplrrFileItemHash;
}

export interface gXplrrFileItemHash {
    [key: number]: gXplrrFileItemOpened;
}

export interface gXplrrFileItemOpened {
    opened: boolean;
    currentValue: string;
    splitValues: string[];
    splitLength: number;
    itemLevel: number;
    pageNumExtracted: number;
}

export interface gXplrrSpaceIndex {
    [key: string]: gXplrrContentListFileOrder;
}

export interface gXplrrContentListFileOrder {
    [key: string]: number;
}

export interface gChatlogItem {
    key: string;
    datestamp: Date;
    usermail: string;
    question: string;
    response: string;
    positive: number;
    feedback: string;
    convo_id: number;
    collecteddata?: any;
    ts?: string; // timestamp in iso format
    audio_logs: string[];
    groupid: string;
    groupname: string;
}

export interface gComplogItem {
    key: number;
    usermail: string;
    question: string;
    response: string;
    positive: number;
    feedback: string;
    convo_id: number;
    groupid: string;
    responsetokens: number;
    prompttokens: number;
    interaction_guid: string;
    responsetokens_precog: number;
    prompttokens_precog: number;
    responsetokens_chartcog: number;
    prompttokens_chartcog: number;
    responsetokens_post_cog: number;
    prompttokens_post_cog: number;
}


export interface gSyncLogItem {
    id: string;
    stamp: Date;
    tid: string;
    fid: number;
    filename: string;
    rid: string;
    page_count: number;
    symbol_count: number;
    doctype: string;
    sid: string;
    groupname: string;
}

// 🕰️ original uploaded-file entry from files.rehydrate jsonb
export interface grehydrateentry {
    rekey: string;
    blobpath: string;
    filename: string;
}

// 🕰️ invoicedata version row (versioning table)
export interface gversionrow {
    id: number;
    fid: number;
    uid: string | null;
    stamp: Date;
    upd_type: string | null;
    invoicedata?: any;
    rehydrate?: Record<string, grehydrateentry> | null;   // 🕰️ original uploaded-file blobs, keyed by upload datetime (yyyymmddHHsshh)
    owner_userid?: string | null;                          // 🕰️ file owner id (for building version blob path)
    filename?: string | null;                              // 🕰️ current file name
    // computed client-side: the uploaded file aligned to this metadata version
    linkedFile?: grehydrateentry | null;
    isLatest?: boolean;                                    // 🕰️ true for the current (latest) version — disabled in the UI
}

// 🧩 saved detailsList column view (server-backed).
// viewcols is stored as jsonb: legacy rows hold a plain string[] of ordered keys;
// newer rows hold a gviewpayload object ({cols, valueFilters}). Both are supported.
export interface glistview {
    id: number;
    groupid: string | null;
    userid: string | null;
    viewcols: string[] | gviewpayload;
    ispublic: boolean | null;        // visible to all users with access to the group
    defaultview: string[] | null;    // userids that set this view as their default
    viewname: string | null;
}

// 🧪 richer view payload: ordered visible columns + per-column value filters
export interface gviewpayload {
    cols: string[];
    valueFilters?: Record<string, string[]>;
}

export interface gdynfilter {
    category: string;
    groups: string;
}
export interface qsentenceforaudio {
    text: string;
    answerid: string;
    chunkid: string;
    convoid: string;
}

export const emptyaudiosentence: qsentenceforaudio = { text: "", answerid: "", chunkid: "", convoid: "" };

export interface gConf {
    promptTemplate: string;
    retrieveCount: number;
    retrievalMode: string;
    useSemanticRanker: boolean;
    shouldStream: boolean;
    useSemanticCaptions: boolean;
    searchOnly: boolean;
    useHighlightsAsSource: boolean;
    useSuggestFollowupQuestions: boolean;
    isDark: boolean;
    experimentalFeatures: boolean;
    showDocLibInChatTab: boolean;
    sourceHighlighting: boolean;
}

export interface ggroupcardprops {
    selectedGroup: gselectedgroup;
    handleGroupListClick: (groupid: string, groupname: string, permissionlevel: number) => void;
}

export interface ggroupcardslistprops {
    grL: ggroupcardprops[];
    onNewGroupClick: () => void;
    compLvl: number;
    permissionLevelsMap: { [key: number]: string };
    newSpacePyro: string;
    user: guser;
    activeComp: gactivecomp;
    navChatLib: (loc: string, groupid: string) => void;
}

export interface greindexparams {
    fileString: string;
    selectedGroup: gselectedgroup;
    userId: string;
    company: string;
    header: any;
    modString: string;
    idString: string;
    doc_page_len: string;
}

export interface gsuggestedquestions {
    fileid: number;
    suggestedquestions?: string;
}

export interface gingestioniteminfo {
    groupid: string;
    companyid: string;
    userId: string;
    fdFlName: string;
    fdFlSize: string;
    sectionoverlap: string;
    maxsectionlength: string;
    sentencesearchlimit: string;
    invoicesgroup: string;
    usedocintel: string;
    forceocr: string;
    assistanttype: string;
    contenttype_config: gcontenttypeconfig;
    aiquestionslang: string;
    perchunkmeta: string;
    pdfcontentlist: string;
    enhance_img: string;
    extraone?: string;
    extratwo?: string;
    staggerthrottling?: boolean;
}

export interface guploadfileinfodata {
    groupid: string;
    companyid: string;
    userId: string;
    fdFlName: string;
    fdFlSize: string;
    sectionoverlap: string;
    maxsectionlength: string;
    sentencesearchlimit: string;
    invoicesgroup: string;
    usedocintel: string;
    forceocr: string;
    assistanttype: string;
    contenttype_config: gcontenttypeconfig;
    aiquestionslang: string;
    perchunkmeta: string;
    pdfcontentlist: string;
    enhance_img: string;
    convolang?: string;
    splitinv?: string;
    usenewmodel?: string;
    uselatestretrieval?: string;

}

export interface gtiers {
    tier: number;
    msgsplmt: number;
    docsplmt: number;
    spslmt: number;
    name: string;
    monthlypayment: number;
    demosps: number;
}

export interface gInnerMap {
    [key: string]: boolean;
}

export interface grecentconvosaccrossspaces {
    groupid: string;
    lastinteractiontimestamp: string;
    name: string;
    groupname: string;
    key: string;
    hideroottabs: number;
}

export interface gfeedback {
    feedback: string;
    pos: number | null;
    interaction_guid: string;
}

export interface gcustominvoiceinstructions {
    id: number;
    groupid: string;
    contractorid: string;
    fieldname: string;
    instruction: string;
    userid: string;
}

export interface gcustominvoiceinstructionscallout {
    isOpen: boolean;
    path: string;
    instructions: gcustominvoiceinstructions[];
}

export interface gscopedinvrulepostval {
    items_not_vat?: boolean;
    trim_all_types?: boolean;
    [k: string]: any;
}

export interface gscopedinvrulepremain {
    override_floor?: boolean;
    lower_min_to_apply_min_items?: boolean;
    allow_items_without_qty_and_price?: boolean;
    [k: string]: any;
}

export interface gscopedinvrule {
    id?: number;
    supplier_id: string;
    info?: string | null;
    post_validation_rules: gscopedinvrulepostval;
    pre_main_rules: gscopedinvrulepremain;
}

export interface gtranscriptentry {
    speakerId: string;
    speakerName: string;
    text: string;
    isEditing: boolean;
    isRenaming: boolean;
    editText?: string;
    start?: number;
    end?: number;
    duration?: number;
    offset_ticks?: number;
    duration_ticks?: number;
}

export interface gaianalysisoptions {
    instructions: string;
}

export interface gtranscriptobject {
    id?: number;
    fileid?: string | null;
    content: gtranscriptentry[];
    groupid: string;
    userid: string;
    stamp?: string;
    key: number;
    transcriptname: string;
}

export interface gtranscriptpublish {
    selectedGroup: gselectedgroup;
    loggedInUser: gloggedinuser;
    transcript: gtranscriptentry[];
    transcriptKey: string;
    transcriptName: string;
}

export interface qconvoupload {
    selectedGroup: gselectedgroup;
    loggedInUser: gloggedinuser;
    convo: gqasimplified[];
    convoName: string;
}

export interface gpdftextitem {
    pageIndex: number;
    pageNumber: number;
    itemIndex: number;
    str: string;
}

export interface gdiff {
    diffid: string;
    fid1: number;
    fid2: number;
    results: diffresults[];
}

export interface diffresults {
    mapping1: number[];
    mapping2: number[];
    tagged_1_original: string;
    tagged_2_original: string[];
    [key: string]: any;
}

export type gcaption = {
    content: string;
    filename: string;
    page: string;
    fileid: string;
    chunkid?: number;
};

// indexing metadata - automate advanced preagent indexing results for paragraph - used for paragraph highlighing and later for diff highlighting
export interface gautoparagraphresult {
    fileid: number;
    paragrphs: gautoparagraph[];
}

export interface gautoparagraph {
    role: string | null;
    spans: gspan[];
    content: string;
    kgnf_id: number;
    tot_pos: number;
    kgnf_lines: gkgnfline[];
    bounding_regions: gboundingregion[];
}

interface gkgnfline {
    spans: gspan[];
    content: string;
    polygon: gpolypoint[];
    tot_pos: number;
}

export interface gdiffresponse {
    id: number;
    diffid: string;
    fid1: number;
    fid2: number;
    overview: string;
    paragraphs: gdiffparagraphresult[];
}

// diff paragraphs - used for diff highlighting
export interface gdiffparagraphresult {
    fid: number;
    all_lines: glinetagged[];
    paragraphs: gdiffparagraph[];
}

export interface gdiffparagraph {
    role: string | null;
    spans: gspan[];
    content: string;
    kgnf_id: number;
    tot_pos: number;
    kgnf_lines: glinetagged[] /*same as line array but located in corresponding paragraph*/;
    diff_overview?: string;
    content_tagged?: string;
    valid_diff_tags?: gvaliddifftag[];
    bounding_regions: gboundingregion[];
    invalid_diff_tags?: invaliddifftag[];
    paragraph_group_id: number;
    are_there_differences?: boolean;
    grid?: Number;
}

export interface glinetagged {
    c_key: string;
    spans: gspan[];
    content: string;
    polygon: gpolypoint[];
    tot_pos: number;
    content_tagged?: string;
    page_num?: number;
    para_id?: number;
}

export interface gvaliddifftag {
    tag_name: string;
    difference_explanation: string;
}

export interface invaliddifftag {
    tag_name: string;
    why_invalid: string;
}

interface gboundingregion {
    polygon: gpolypoint[];
    page_number: number;
}

interface gpolypoint {
    x: number;
    y: number;
}

interface gspan {
    length: number;
    offset: number;
}

export interface gailinks {
    next_page_links: string[] | undefined;
    requested_links: grequestedlink[] | undefined;
}

export interface grequestedlink {
    0: number; // Numeric ID
    1: string; // Link description (text label)
    2: string; // URL path
}

export interface gspeakprops {
    isSpeaking: boolean;
    isPaused: boolean | null;
}

export interface CustomElement extends HTMLElement {
    listenerAdded?: boolean;
}

export interface gfanalyse {
    filename: string;
    structured_data_per_page: any;
}

export interface gjsonprop {
    name: string;
    description: string;
    type: "string" | "number" | "boolean" | "array" | "object";
    validation_source?: string;
    linked_fields?: string[];
    items?: gjsonprop[];
}

export interface gconvorunonmessagepart {
    message: string;
    convostamp: number;
}

export interface grecognitionitem {
    msg: string;
    cadancestamp: number;
}

export interface grecognitionresult {
    recognized: grecognitionitem[];
    segments: grecognitionitem[];
}

export interface gcongoinedrecognitionresult {
    conjoined_msg: string;
    conjoined_segments: string;
}

export interface gconvocollectionconf {
    values: any[];
    keyname: string;
    shouldGo: boolean;
    joinkeys: string[];
    conf: gjsonprop[];
}

export interface gqasimplified {
    role: string;
    content: string;
}

export type landStoryIds = 'aap' | 'acc' | '';

export interface storyNavRes {
    storyid: landStoryIds;
    hasparam: boolean;
    haspath: boolean;
}


export interface camp_c_onf  {
    tarid: string;
    tarph: string;
    tarname: string;
}

export type extrtypes = 'string' | 'number' | 'boolean' | 'array' | 'object';

export type qaconftypes = 'string' | 'number' | 'boolean' | 'array' | 'object';

export type qaconfsourcetypes = 'string' | 'number' | 'boolean' | 'array';

export const extrtypesarray = ['string', 'number', 'boolean', 'array', 'object'];

export type extrlevels = 'main' | 'item'; // invoice fields type - main for header props, item for line item props

export type reco_type_choices = 'reconcile' | 'verify' | 'none';

export type chartTypeResult = 'isArrayFull' | 'isArrayEmpty' | 'isElse' | 'isNull';

export type invMissItemsKeys = 'items_with_insufficient_data' | 'items_with_mismatches'

/** `BPA` field & `INV` custom field
 * - `name`: Field Name
 * - `description`: AI Instruction
 * - `type`: Field Data Type
 * - `validation_source`: Optional source for validation (e.g., list of valid values)
 * - `identificator`: Optional flag indicating if the field is an identifier
 * - `display_name`: Optional display name for the field
 * - `linked_fields`: Optional array of linked field IDs
 * - `items`: Opt array of sub-fields (for object or array types)
 * - `answer_length`: Optional expected answer length (for str type)
 * - `global_prop`: Optional flag indicating if the property is global
*/
export interface gextrprop {
    name: string;
    description: string;
    type: extrtypes;
    validation_source?: string;
    filter_column?: string;           // optional, name of the corresponding field on the validation source
    identificator?: boolean;
    display_name?: string;
    linked_fields?: string[];
    items?: gextrprop[];
    answer_length?: string;     // optional, used for string type
    global_prop?: boolean;      // optional, look for this always
    level?: extrlevels;         // optional, item or "root"
    campaignid?: string;         // optional, for future use in campaign based extractions
    mcp_sourced?: number;         // optional
}

/** INV Field Instructions
 * - `instr`: Instruction for AI
 * - `level`: "main" for header fields, "item" for line item fields
 * - `fieldid`: Unique field identifier
 * - `validation_source`: Optional source for validation (e.g., list of valid values)
 * - `is_required`: Optional flag indicating if the field is required
 * - `is_key`: Optional flag indicating if the field is a key identifier (e.g., invoice number)
 * - `source_specific_instr`: Optional additional instructions specific to the data source
 * - `predefined_process`: Optional predefined process to apply ("reconcile" | "verify" | "prefilter" | "ground" | "validate")
 * - `filter_condition`: Optional condition to filter extracted values (e.g., "gt" for greater than, "contains" for substring match)
 * - `filter_column`: Optional column to apply the filter condition on
*/
export interface gextractionfieldlistinstruction {
    instr: string;
    level: string;
    fieldid: string;
    validation_source?: string;
    is_required?: string;
    is_key?: string; // 'Yes' | 'No'
    source_specific_instr?: string;
    predefined_process?: string;
    filter_condition?: "eq" | "gt" | "lt" | "gteq" | "lteq" | "contains" | "not_contains";
    filter_column?: string;
    is_or_filtering?: string; // 'Yes' | 'No'
    filter_priority?: number; // optional, priority for the filter condition
}

// extraction config - qna config
export interface qaconf {
    qid: string;
    qtype: qaconftypes;
    qoutputtype: qaconfsourcetypes;
    qtag: string;
    question: string;
    items?: qaconf[];
}


/** `INV` › Main config for invoice handling
 * - `excl`: INV Fields to exclude
 * - `instr`: DPA Field Schema
 * - `allowed_deviation`: INV Recalc allowed deviation in currency
 * - `custom_props`: Inv Custom Field Schema
 * - `use_v4_extraction`: New extractor version
 * - `enable_custom_props`: Allow custom properties in extraction
 * - `use_latest_model`: Use latest models
 * - `enable_expanded_extraction`: Enable expanded extraction for more fields (other1 to other4)
 * - `preferred_currency`: Preferred currency
 */
export interface gextractionfieldlist {
    excl: string[];
    instr: gextractionfieldlistinstruction[];
    allowed_deviation?: number;
    custom_props?: gextrprop[];
    use_v4_extraction?: number;
    enable_custom_props?: number;
    use_latest_model?: number;
    enable_expanded_extraction?: number;
    extended_cli_code?: number;
    preferred_currency?: string;
    full_pre_precessing?: number;
    hardcode_language?: string;
    adv_post_check?: number;
    align_rotation?: number;
    adjust_small_diffs?: number;
    inv_do_callback?: number;
    inv_callback_url?: string;
    inv_pre_agent?: number; // 0️⃣ ￫ run V1 Layout Alignement, 1️⃣ ￫ don't run V1 Layout Alignement (inv_pre_agent)
    po_editing_enabled?: number; // 1 ￫ enable PO match change, 0/empty ￫ disabled
    po_delivery_tracking_on?: number; // 1 ￫ track PO item delivery from approved invoices, 0/empty ￫ disabled
    allow_linked_data_editing?: number; // 1 ￫ allow editing linked PO source data (po_line_items) from the dash list, 0/empty ￫ disabled
    props_to_show?: string; // fields to show in dropdown for item po match change divided by
    props_to_show_in_inv_lines?: string; // default fields to show
    props_to_show_in_po_lines?: string; // default fields to show in PO lines
    do_inv_item_combining?: number; // 1 ￫ enable item combining in invoice, 0/empty ￫ disabled
}


/** ## **DPA** Content Type Schema
 * Sub of **gcontenttypeconfig** & **postaianalysisoption**
 * - `type`: Content Type ID
 * - `description`: Instructions for AI to determine if content belongs to this type and for extraction
 * - `fields`: Array of fields to extract with their own instructions and validation
 * - `autofield`: Whether to attempt automatic extraction of fields without explicit instructions
 * - `qaconf`: Optional array of questions to ask the user for this content type, if AI is uncertain or as a follow-up after extraction
*/
export interface gcontenttype {
    type: string;
    description: string;
    fields: gextrprop[];
    autofield: boolean;
    qaconf?: qaconf[];
}

/** ### DPA Extraction Config › gcontenttypeconfig
 *  - `contenttype`: Array of extraction schemas for Base Extraction
 *  - `postaianalysisoptions`: Post Extraction Config
 *  - `force_visual_ai`: Whether to force visual AI
 *  - `high_intel_post`: Whether to enable high intelligence post processing
 * @example
 * ```json
{
    "contenttype": [
        {
            "type": "all_content",
            "fields": [],
            "autofield": true,
            "description": "All Content not covered by other Content Types"
        }
    ],
    "high_intel_post": true,
    "postaianalysisoptions": {
        "preconfopt": 4,
        "contenttype": [
            {
                "type": "all_content",
                "fields": [
                    {
                        "name": "Field Name",
                        "type": "string",
                        "items": [],
                        "description": "AI Instruction Here",
                        "validation_source": ""
                    },
                ],
                "qaconf": [],
                "autofield": false,
                "description": "All Content not covered by other Content Types"
            }
        ]
    }
}
*/


export type geninstr = {
    generalinstruction: string;
    whendonesendtourl?: string;
}

export const emptyGenInstr: geninstr = {
    generalinstruction: "",
    whendonesendtourl: ""
};

export interface gcontenttypeconfig {
    contenttype: gcontenttype[];
    postconfigs?: Record<string, geninstr>;
    postaianalysisoptions?: postaianalysisoption;
    force_visual_ai?: boolean;
    high_intel_post?: boolean;
    extended_post?: number;
    hardcode_language?: string;
    limit_pages_for_extraction?: number;
    align_rotation?: number;
    allow_human_result_edits?: number;
    show_base_extract_in_preview?: number;
}

/** ### DPA Post AI Analysis
 * Sub of **gcontenttypeconfig**
 * - `preconfopt`: Post Extr Approach: `1` Don't Run, `2` Predef 01, `3` Custom, `4` Multi-Type [beta]
 * - `postaianalysiscustom`: Array of **gextrprop**
 * - `contenttype`: Array of content types **gcontenttype**
*/
export interface postaianalysisoption {

    /** Configuration Type */
    preconfopt: string;

    /** Post Extraction Types & Custom Properties */
    postconfigs?: Record<string, geninstr>;

    /** Post Extraction Types & Custom Properties */
    postaianalysiscustom?: gextrprop[];

    /** Post Extraction Content Types */
    contenttype?: gcontenttype[];
}

export const gemptyextrprop = {
    name: "",
    description: "",
    type: "string" as "string",
    validation_source: "",
    identificator: false,
    display_name: "",
    linked_fields: [],
    items: [],
    global_prop: false
};

export const qconfemptyprop: qaconf = {
    qid: "",
    qtype: "string",
    qoutputtype: "string",
    qtag: "string" as "string",
    question: ""
};

// ─── Campaigns ───────────────────────────────────────────────────

export interface gcampaign {
    id: number;
    campaign_display_name: string;
    campaign_id: string;
    space_id: string;
    campaign_config: gcampaignconfig;
    campaign_start_date: string;
    campaign_end_date: string;
    created_at: string;
    updated_at: string;
    scheduled_count: number;
    completed_count: number;
    total_targets: number;
    inactive: number;
}

export interface gcampaignconfig {
    description?: string;
    /** delivery channel for the campaign — chosen at creation, immutable after. defaults to 'phone' for legacy/empty configs */
    type?: 'phone' | 'chat';
}

export interface gcampaigntarget {
    target_id: string;
    target_name: string;
    target_phone_number: string;
    target_email: string;
    /** position/role of the contact, used to AI-match a suitable data document for chat-invite campaigns */
    target_position?: string;
    /** AI-matched file ids per campaign — array of single-key objects: [{ "<campaign_id>": ["<fileid>"] }] */
    target_campaign_fids?: Record<string, string[]>[];
    target_meta: Record<string, any>;
    active_campaign_ids: string[];
    progress_status: string | null;
    convo_ids: string[] | null;
    /** JSONB schedule state per campaign_id key — array of events per campaign */
    schedules?: Record<string, gcampaignscheduleentry[]>;
    /** collecteddata from convodata table, keyed by convo_id */
    convo_data?: Record<string, Record<string, any>>;
}

export interface gcampaignscheduleentry {
    campaign_id:     string;
    state:           'pre-scheduling' | 'scheduled' | 'delayed_by_contact' | 'complete' | 'cancelled' | 'campaign_ended' | 'post_analysis' | 'escalate' | 'retry' | 'call_initiated' | '';
    scheduled_time?: string;
    job_id?:         string;
    convo_id?:       string;
    delay_info?:     string;
    delay_greeting?: string;
    updated_at?:     string;
    outcome?:            'complete' | 'reschedule' | 'retry' | 'escalate';
    outcome_reasoning?:  string;
    summary?:            string;
    reschedule_window?:  string | null;
    outbound_greeting?:  string;
    inbound_greeting?:   string;
    escalation_note?:    string | null;
}

export interface gcampaignprogress {
    id: number;
    campaign_id: string;
    target_id: number;
    status: string;
    convo_ids: string[] | null;
    target_name: string;
    target_phone_number: string;
}

/** one flat chatlog turn for a chat-campaign member (joined contact + chat reporting data) */
export interface gcampaignchatmemberrow {
    target_id: string;
    target_name: string;
    target_phone_number: string;
    target_email: string;
    target_position?: string | null;
    userid: string | null;
    key: number | null;
    question: string | null;
    response: string | null;
    positive: number | null;
    feedback: string | null;
    convo_id: number | null;
    collecteddata?: Record<string, any> | null;
    stamp?: Date | null;
}


export type livecachemapitem = {
    fileid: number;
    modified: Date;
    docstatus: string;
}

export type livecachemap = Map<number, livecachemapitem>;

export type livecacheactions = {
    forRefresh: livecachemap;
    forRemoval: livecachemap
}

export type cachemantimes = {
    latest: any;
    group_upd: any;
    file_upd: any;
}

export interface gconvoitem {
    key: string;
    name: string;
}

export interface guploadtextitem {
    id: string;
    value: string;
    extra1?: string;
    extra2?: string;
}

export type RecognizedProcessObj = {
    final_upstream_msg: string;
    should_run_oai: boolean;
    conjoined_obj: {
        conjoined_msg: string;
        conjoined_segments: string;
    };
    conj_clean: string;
    value_valid_bot_not_in_data: string;
    additional_instructions: string;
    msg_ovrride: string;
};

export type PrefixSuffixSplitResult = [number | null, Set<string>, Set<string>];

export type ExractionFieldConfig = Record<string, any>; // adjust if you have a more specific type

export interface highLightItem {
    startIndex: number;
    endIndex: number;
    element: HTMLElement;
    processedText: string;
}

export type DataPoint = {
    content: string;
    filename: string;
    pages: any[];
    fileid: string;
};

export type ginvoicetablesort = {
    column: string;
    isSortedDescending: boolean
}

export interface InteractionFeedbackItem {
    feedback: string;
    positive: "Positive" | "Negative" | "No Feedback";
    numericFeedback?: number;
    numericCount?: number;
}

export const get_empty_dpa_content_type = () => {
    return { type: "", description: "", autofield: false };
};

export const qaconftypesarray:string[]  = [
    "string",
    "number",
    "boolean",
    "array",
    "object"
];

export const new_content_type_config    = {
    type: "",
    description: "",
    autofield: false
};


export const get_global_file_cache_empty = () => {
    return new Map<
        string,
        {
            base64string: string;
            fileid: string;
            name: string;
            modified: string;
            pageContent: Array<{ page_num: string; text: string }>;
            pageDimensions: Array<{ page_number: string; width: number; height: number }>;
        }
    >();
};



export type tooltipContentItem = {
    title: string;
    content: string;
    classToUse: string;
}

export type tooltipContentGroup = {
    title: string;
    items: tooltipContentItem[];
    classToUse: string;
}


export type licmeasure = 'pages' | 'months' | '';
export type licsvclevel = 'Usage' | 'Premium' | 'Usage Interval' | '';
export type lictype = 'usage' | 'support' | '';




export interface gintervalpricingrules {
    'Minimum Monthly Usage': number;
    'Maximum Monthly Usage': number;
    'Support Price Under Maximum': number;
    'Support Price Over Maximum': number;
}


export interface glicenceextraprops {
    'Interval Pricing'?: number;
    'Interval Pricing Rules'?: gintervalpricingrules;
    'Official Activate Date'?: string;
}


export interface gLicense {
    id: number;
    coid: string;
    lic_type: lictype;
    is_active: number;
    usage_amount: number;
    service_level: licsvclevel;
    term: number;
    activated_on: string;
    measure: licmeasure;
    total_pages_synced: number;
    op_type: string;
    allocated_pages?: number;
    cumulative_pages_total?: number;
    monthly_pages?: Record<string, number>;

    lic_extra_props?: glicenceextraprops;
}



export interface gsynclog {
    id: number;
    stamp: string;
    tid: string;
    fid: number;
    filename: string;
    page_count: number;
    rid: string;
    symbol_count: number;
    doctype: string;
    sid: string
}


export interface IDocument {
    key: string;
    fileid: number;
    name: string;
    value: string;
    iconName: string;
    fileType: string;
    modifiedBy: string;
    dateModified: string;
    dateModifiedValue: number;
    fileSize: string;
    fileSizeRaw: number;
    full_path: string;
    groupNames: string[];
    groupIds: string[];
    filerole: string;
    ownerid: string;
    filepermlevel: number;
    contentlist: gcontentlist[];
    pagemap: gpagemap;
    isDeleting?: boolean;
    sourcetype: string;
    sourceurl: string;
    docstatus: string;
    displayName: string;
    invoicedata?: string;
    doc_category: string;
    invoicedataobj?: any;
    transcription?: gtranscriptentry[];
    transcriptionkey?: number;
    transcriptname?: string;
    diffids: number[];
    approved?: number;
    tag: string;
    aiinteractions?: string[];
    parent_url: string;
    file_url: string;
    status_info?: string;
    rekey?: string;
    doc_cat_ai?: string;
    docsummary?: any;
    ext_stamp?: Date | null;
    dash_list?: number;
}
